import { models } from "powerbi-client";
import AppSetting from "config/AppSetting";
import { handleUserRole } from "utils";

/**
 * Locked filter contract agreed with Data Engineering (PMP Dashboard embed handover).
 * These map to the semantic model column that scopes a user to their own data; they must
 * not be changed without a matching change on the Power BI model side.
 */
export const DASHBOARD_FILTER_TABLE = "dim_UserAccess";
export const DASHBOARD_FILTER_COLUMN = "user_id";

/**
 * Builds the role-based default filter applied to the embedded Power BI report.
 *
 * Per the handover role matrix:
 * - OPEX Admin / OPEX+TOO users (identified by {@link handleUserRole}) see the whole
 *   company, so no filter is applied (empty array).
 * - Every other role is scoped to their own data via `dim_UserAccess[user_id]` matching
 *   their IdentityUserID as-is.
 */
export const getDashboardFilters = (): models.IBasicFilter[] => {
  const isFullAccess = handleUserRole(AppSetting.localStorageValue.role.get());
  if (isFullAccess) {
    return [];
  }

  const internalUserID: string | undefined =
    AppSetting.localStorageValue.user.get()?.identityUserInfo?.internalUserID;
  if (!internalUserID) {
    return [];
  }

  return [
    {
      $schema: "https://powerbi.com/product/schema#basic",
      target: { table: DASHBOARD_FILTER_TABLE, column: DASHBOARD_FILTER_COLUMN },
      operator: "In",
      values: [internalUserID],
      filterType: models.FilterType.Basic,
    },
  ];
};
